
class MalaloPriceSlider extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    const priceRange = this.nextElementSibling;
    if (!priceRange || priceRange.tagName !== 'PRICE-RANGE') return;

    const rangeWrap = this.querySelector('.malalo-price-slider__range-wrap');

    this.minSlider = this.querySelector('.malalo-price-slider__range--min');
    this.maxSlider = this.querySelector('.malalo-price-slider__range--max');
    this.fill = this.querySelector('.malalo-price-slider__fill');

    const fields = priceRange.querySelectorAll('input[type="number"]');

    if (!rangeWrap || !this.minSlider || !this.maxSlider ||
        !this.fill || fields.length !== 2) return;

    this.minField = fields[0];
    this.maxField = fields[1];
    this.cap = Number(this.dataset.priceCap) || 200;

    // Prijslabels boven beide bolletjes aanmaken
    this.minBubble = document.createElement('span');
    this.minBubble.className = 'malalo-price-slider__bubble';
    this.minBubble.setAttribute('aria-hidden', 'true');

    this.maxBubble = document.createElement('span');
    this.maxBubble.className = 'malalo-price-slider__bubble';
    this.maxBubble.setAttribute('aria-hidden', 'true');

    rangeWrap.append(this.minBubble, this.maxBubble);

    this.initialized = true;
    this.updateFromFields('min', true);

    [this.minSlider, this.maxSlider].forEach((slider, index) => {
      const which = index === 0 ? 'min' : 'max';

      slider.addEventListener('pointerdown', () => {
        this.showBubble(which);
      });

      slider.addEventListener('pointerup', () => {
        this.hideBubbles();
      });

      slider.addEventListener('pointercancel', () => {
        this.hideBubbles();
      });

      slider.addEventListener('blur', () => {
        this.hideBubbles();
      });

      slider.addEventListener('input', event => {
        event.stopPropagation();

        let min = Number(this.minSlider.value);
        let max = Number(this.maxSlider.value);

        if (index === 0) min = Math.min(min, max);
        else max = Math.max(max, min);

        this.updateUI(min, max, true);
        this.showBubble(which);
      });

      slider.addEventListener('change', event => {
        event.stopPropagation();

        // Bestaande Shopify-prijsfilter bijwerken
        this.minField.dispatchEvent(new Event('change'));
        this.maxField.dispatchEvent(new Event('change'));
        this.maxField.dispatchEvent(
          new Event('input', { bubbles: true })
        );
      });
    });

    this.minField.addEventListener('input', () => {
      this.updateFromFields('min');
    });

    this.maxField.addEventListener('input', () => {
      this.updateFromFields('max');
    });

    [this.minField, this.maxField].forEach(field => {
      field.addEventListener('blur', () => {
        this.updateFromFields('min', true);
      });
    });
  }

  showBubble(which) {
    this.minBubble.classList.toggle(
      'is-visible', which === 'min'
    );

    this.maxBubble.classList.toggle(
      'is-visible', which === 'max'
    );
  }

  hideBubbles() {
    this.minBubble.classList.remove('is-visible');
    this.maxBubble.classList.remove('is-visible');
  }

  clamp(value, fallback) {
    if (value === '') return fallback;

    const number = Number(value);
    if (!Number.isFinite(number)) return fallback;

    return Math.min(this.cap, Math.max(0, number));
  }

  updateFromFields(changed, normalize = false) {
    let min = this.clamp(this.minField.value, 0);
    let max = this.clamp(this.maxField.value, this.cap);

    if (min > max) {
      if (changed === 'min') {
        max = min;
        this.maxField.value = String(max);
      } else {
        min = max;
        this.minField.value = String(min);
      }
    }

    if (normalize) {
      this.minField.value = String(min);
      this.maxField.value = String(max);
    }

    this.updateUI(min, max, false);
  }

  updateUI(min, max, updateFields) {
    this.minSlider.value = String(min);
    this.maxSlider.value = String(max);

    if (updateFields) {
      this.minField.value = String(min);
      this.maxField.value = String(max);
    }

    const minPercent = (min / this.cap) * 100;
    const maxPercent = (max / this.cap) * 100;

    this.fill.style.left = `${minPercent}%`;
    this.fill.style.width = `${maxPercent - minPercent}%`;

    // Actuele bedragen in de prijslabels
    this.minBubble.textContent = `€${min}`;
    this.maxBubble.textContent = `€${max}`;

    // Labels uitlijnen met het midden van de 26px bolletjes
    this.minBubble.style.left =
      `calc(${minPercent}% + ${13 - minPercent * 0.26}px)`;

    this.maxBubble.style.left =
      `calc(${maxPercent}% + ${13 - maxPercent * 0.26}px)`;
  }
}

if (!customElements.get('malalo-price-slider')) {
  customElements.define('malalo-price-slider', MalaloPriceSlider);
}
